import { createFileRoute } from "@tanstack/react-router";

import { SettingsPage } from "@/features/accounts/pages";

export const Route = createFileRoute("/_app/settings/")({
  component: SettingsPage,
});
